import { Hourglass } from "lucide-react";
import * as s from "./ComingSoonCard.style.css";
import type { ComingSoonCardProps } from "./ComingSoonCard.types";

export type { ComingSoonCardProps } from "./ComingSoonCard.types";

export const ComingSoonCard = ({ title, message, icon }: ComingSoonCardProps) => (
  <div className={s.card} role="status">
    <span className={s.iconWrap} aria-hidden>
      {icon ?? <Hourglass size={18} />}
    </span>
    <div className={s.text}>
      <p className={s.title}>{title}</p>
      <p className={s.message}>{message}</p>
    </div>
  </div>
);
